import React, { useEffect , useState, useRef  } from 'react';
import { useLocation, Navigate } from 'react-router-dom';

function LinkedInCallback() {
  const location = useLocation();
  const [error, setError] = useState(null);
  const hasCalledRef = useRef(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    console.log(searchParams);
    const code = searchParams.get('code');
    console.log(code);
    
    // Prevent multiple API calls using ref
    if (code && !hasCalledRef.current) {
      hasCalledRef.current = true;
      console.log('Making API call...');
      const access = async (code) => {
        try {
          let res = await fetch("https://ecoprismapi.azurewebsites.net/linkedin-token", {
            method: "GET",
            headers: {
              'Content-type': 'application/x-www-form-urlencoded',
              'code':code
            }
          });
          
          if (res.status === 200) {
            let resJson = await res.json();
            if (resJson !== null && resJson.access_token) {
              console.log(resJson);
              const accessToken=resJson.access_token;
              if (accessToken) {
                let res1 =await fetch("https://ecoprismapi.azurewebsites.net/api-link", {
                  method: "GET",
                  headers: {
                    'token': accessToken,
                  }
                });
                if (res1.status === 200) {
                  let resJson1 = await res1.json();
                  if (resJson1 !== null) {
                    console.log(resJson1);
                    console.log(resJson1.name);
                    console.log(resJson1.picture);
                    
                    // Check if name exists before processing
                    if (resJson1.name && resJson1.email) {
                      const formattedName = resJson1.name.toLowerCase().replace(/\s/g, '');
                      localStorage.setItem('vanity', formattedName);
                      localStorage.setItem('fullname', resJson1.name);
                      localStorage.setItem('picture', resJson1.picture || '');
                      localStorage.setItem('userName', resJson1.email);
                      const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000; 

                      const codeData = {
                        code: code,
                        expirationTime: expirationTime,
                      };
                      localStorage.setItem('linkedinCode', JSON.stringify(codeData));
                      window.close();
                    } else {
                      console.error('LinkedIn profile data incomplete:', resJson1);
                      setError('LinkedIn profile data is incomplete. Please try again.');
                    }
                  }
                }
                else{
                  console.error('Failed to fetch LinkedIn profile. Status:', res1.status);
                  setError('Failed to fetch LinkedIn profile. Please try again.');
                }
              }
            } else {
              console.error('No access token received from LinkedIn API');
              setError('Failed to get access token. Please try again.');
            }
          } else {
            console.error('LinkedIn token API failed. Status:', res.status);
            setError('LinkedIn authentication failed. Please try again.');
          }
        } catch (error) {
          console.error('Error during LinkedIn authentication:', error);
          setError('An error occurred during authentication. Please try again.');
        }
      };
      access(code);
    }
  }, [location]);

  if (error) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h3>Authentication Error</h3>
        <p>{error}</p>
        <button onClick={() => window.close()}>Close</button>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>Processing LinkedIn authentication...</p>
    </div>
  );
}

export default LinkedInCallback;
